// ** Redux
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################
export const getSupportJson = createAsyncThunk(
	"pages/support/getSupportJsonNew",
	createApiCall(async ({ language, slug, isCategory, isArticle }, client) => {
		client.modifyLanguageHeader(language);
		const response = await client.get("/datezone/help", {
			params: {
				slug,
				category: isCategory ? "true" : undefined,
				entry: isArticle ? "true" : undefined,
			},
		});

		return { data: response.data, language, counters: response.counters };
	})
);

// ############################################################

// Initial state
const initialState = {
	loading: false,
	loaded: false,
	error: false,
	lang: "",
	title: "",
	data: [],
};

// ############################################################

// Slice
const servicePageSupportSlice = createSlice({
	name: "service-pages/support",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			// getSupportJson
			.addCase(getSupportJson.pending, (state) => {
				state.loading = true;
			})
			.addCase(getSupportJson.fulfilled, (state, action) => {
				state.loading = false;
				state.loaded = true;
				state.error = false;
				state.lang = action.payload.language;
				state.title = action.payload.data[0]?.value;
				state.data = Object.values(action.payload.data) || [];
			})
			.addCase(getSupportJson.rejected, (state) => {
				state.loading = false;
				state.loaded = true;
				state.error = true;
			});
	},
});

// ############################################################

export default servicePageSupportSlice.reducer;

// ############################################################
